import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { GetUnixDate } from "../../components/GetUnixDate/GetUnixDate";
import { InstallationsReport } from "../../services/services";
import { CampaignonvertUnixToGregorian } from "../../components/ConvertUnixToGregorian/ConvertUnixToGregorian";

const ReportInstall = () => {
  const [filtersInstallationsReport, setFiltersInstallationsReport] = useState({
    fromDate: undefined,
    toDate: undefined,
  });
  const [resultInstallationsReport, setResultInstallationsReport] = useState();
  const handleChange = (key, value) => {
    setFiltersInstallationsReport((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <div className="card col-4 mt-3 list-user">
      <div className="background-dataTable">
        <p>گزارش کاربران فعال و نصبی ها</p>

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <DatePicker
            containerStyle={{
              height: "40px",
              borderRadius: "8px",
              color: "#4b5563",
              fontSize: "1rem",
              borderColor: "#c8c8c8",
              borderWidth: "1px",
              borderStyle: "solid",
              width: "210px",
              display: "flex",
              paddingRight: "10px",
              alignItems: "center",
              boxShadow: "none",
              backgroundColor: "#1f1f1f",
            }}
            inputClass="no-outline"
            placeholder="تاریخ را انتخاب کنید"
            style={{ borderRadius: "8px", border: "none" }}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom"
            range
            rangeHover
            value={
              filtersInstallationsReport.fromDate &&
              filtersInstallationsReport.toDate
                ? [
                    new DateObject({
                      calendar: persian,
                      date: filtersInstallationsReport.fromDate,
                    }),
                    new DateObject({
                      calendar: persian,
                      date: filtersInstallationsReport.toDate,
                    }),
                  ]
                : ["", ""]
            }
            onChange={(e) => {
              if (e.length === 2) {
                handleChange("fromDate", GetUnixDate(e[0]));
                handleChange("toDate", GetUnixDate(e[1], true));
              }
            }}
            clearable
            format="YYYY/MM/DD"
          />
          <button
            style={{
              color: "#ffff",
              background: "#86a0ff",
              border: "0px",
              width: "108px",
              height: "39px",
              borderRadius: "8px",
              padding: "2px",
            }}
            onClick={() =>
              InstallationsReport({
                fromDate: CampaignonvertUnixToGregorian(
                  filtersInstallationsReport?.fromDate
                ),
                toDate: CampaignonvertUnixToGregorian(
                  filtersInstallationsReport?.toDate
                ),
              }).then((res) => setResultInstallationsReport(res))
            }
          >
            جستجو
          </button>
        </div>
        {resultInstallationsReport && (
          <div className="row mt-4">
            <div className="col-6 mb-3">
              <div
                style={{
                  backgroundColor: "#4e504e",
                  borderRadius: "8px",
                  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                  padding: "10px 0px 10px 0px",
                }}
              >
                <h6
                  style={{
                    color: "#4b5563",
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                >
                  کاربران فعال
                </h6>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  {resultInstallationsReport?.activeUserCount}
                </p>
              </div>
            </div>
            <div className="col-6 mb-3">
              <div
                style={{
                  backgroundColor: "#4e504e",
                  borderRadius: "8px",
                  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                  padding: "10px 0px 10px 0px",
                }}
              >
                <h6
                  style={{
                    color: "#4b5563",
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                >
                  نصب‌ها
                </h6>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  {resultInstallationsReport?.installationCount}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ReportInstall;
